import { useState, useEffect } from "react";
import MovieCard from "../Component/MovieCard";
import { searchMovies, getPopularMovies } from "../services/api";
import "../css/App.css";
import "../css/Home.css";

const Home = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [movies, setMovies] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPolpulerMovies = async () => {
      try {
        const populerMovies = await getPopularMovies();
        setMovies(populerMovies);
      } catch (err) {
        console.log(err);
        setError("Failed to load");
      } finally {
        setLoading(false);
      }
    };
    loadPolpulerMovies();
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault(); // after press submission, typed value stayed
    if (!searchQuery.trim()) return;
    setLoading(true);
    try {
      const searchReasult = await searchMovies(searchQuery);
      setMovies(searchReasult);
      setError(null);
    } catch (err) {
      console.log(err);
      setError("Fail to search movie....");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home">
      <form onSubmit={handleSearch} className="search-form">
        <input
          type="text"
          placeholder="Search for movies..."
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button type="submit" className="search-button">
          Search
        </button>
      </form>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="movies-grid">
          {movies.map((movie) => (
            <MovieCard movie={movie} key={movie.id} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Home;
